export default __webpack_public_path__ + "static/algorithms-e1ab97582df18943b018918ee627badb.jpg";